module.exports = __webpack_public_path__ + "static/media/bird_making_home_body.6258105c.png";